import { useContext, useEffect, useState } from "react";
import Loading from "../components/Loading";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import searchIcon from "../assets/images/svg/search.svg";
import { Context } from "../context/MainContext";
import { fetchTrainings, fetchTrainingsBySearch } from "../api/adminApi";
import { toast } from "react-toastify";
import Button from "../common/Button";

const Training = () => {
  const { user } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [trainings, setTrainings] = useState([]);

  const formattingOption = {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
  };

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
    if (searchQuery) {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    if (searchQuery && user?.id) {
      setLoading(true);
      try {
        const res = await fetchTrainingsBySearch(
          searchQuery,
          user?.accessToken,
          page,
        );

        setTrainings(res.data?.enrollments);
        setPageCount(res.data.totalPages);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };

  useEffect(() => {
    const handleFetchUsers = async () => {
      if (user?.id && searchQuery === "") {
        setLoading(true);
        try {
          const res = await fetchTrainings(page, user?.accessToken);

          setTrainings(res.data?.enrollments);
          setPageCount(res.data.totalPages);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
          toast.error(message);
        }
      }
    };

    handleFetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, page, user?.accessToken]);

  return (
    <div className="blog">
      {/* <div className="Training__top__form" style={{ marginBottom: 30 }}>
        <input
          placeholder="Search by Order/Payment Id (Paypal)"
          type="text"
          onChange={(e) => setSearchQuery(e.target.value)}
          value={searchQuery}
        />
        <button onClick={handleSearch}>
          <img src={searchIcon} alt="" />
        </button>
      </div> */}
      <div className="blog__main">
        <div className="dashboard__users__top">
          <h3>Training Application</h3>
          {/* <div className="topbar__left__input">
            <input
              placeholder="Search by Name and ID"
              type="text"
              onChange={(e) => setSearchQuery(e.target.value)}
              value={searchQuery}
            />
            <i className="ti-search"></i>

          </div> */}
          {/* <button onClick={handleSearch}>
            </button> */}
        </div>
        <div className="dashboard__users__table">
          <div
            className="dashboard__users__table__body"
            style={{ minWidth: 1450 }}
          >
            <div className="dashboard__users__table__row head">
              <div
                style={{ width: "30px" }}
                className="dashboard__users__table__row__head"
              >
                s/n
              </div>
              <div
                style={{ width: "300px" }}
                className="dashboard__users__table__row__head"
              >
                Course Name
              </div>
              <div
                style={{ width: "100px" }}
                className="dashboard__users__table__row__head"
              >
                Date
              </div>
              <div
                style={{ width: "150px" }}
                className="dashboard__users__table__row__head"
              >
                Duration
              </div>
              <div
                style={{ width: "200px" }}
                className="dashboard__users__table__row__head"
              >
                Client Name
              </div>
              <div
                style={{ width: "250px" }}
                className="dashboard__users__table__row__head"
              >
                Client Email
              </div>
              <div
                style={{ width: "150px" }}
                className="dashboard__users__table__row__head"
              >
                Client Phone no.
              </div>
              <div
                style={{ width: "150px" }}
                className="dashboard__users__table__row__head"
              >
                Payment Id (Paystack)
              </div>
              <div
                style={{ width: "120px" }}
                className="dashboard__users__table__row__head"
              >
                Payment Status
              </div>

              <div
                style={{ width: "150px" }}
                className="dashboard__users__table__row__head"
              >
                Amount
              </div>
              {/* <div
                style={{ width: "100px" }}
                className="dashboard__users__table__row__head"
              ></div> */}
            </div>

            {loading ? (
              <Loading />
            ) : (
              trainings?.map((training, i) => {
                return (
                  <div
                    key={training.id}
                    className="dashboard__users__table__row"
                  >
                    <div
                      style={{ width: "30px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {(page - 1) * 10 + (i + 1)}
                    </div>
                    <div
                      style={{ width: "300px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {training?.courseName}
                    </div>
                    <div
                      style={{ width: "100px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {training?.createdAt?.slice(0, 10)}
                    </div>
                    <div
                      style={{ width: "150px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {training?.period}
                    </div>
                    <div
                      style={{ width: "200px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {`${training?.firstName} ${training?.lastName}`}
                    </div>
                    <div
                      style={{ width: "250px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {training?.email}
                    </div>
                    <div
                      style={{ width: "150px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {training?.phone}
                    </div>
                    <div
                      style={{ width: "150px" }}
                      className="dashboard__users__table__row__data"
                    >
                      <div className="dashboard__users__table__row__data__disc">
                        {training?.paymentId}
                      </div>
                    </div>
                    <div
                      style={{ width: "120px" }}
                      className="dashboard__users__table__row__data"
                    >
                      <p
                        className={`dashboard__users__table__row__data__status ${
                          training?.paymentStatus === "Success"
                            ? "status--success"
                            : training?.paymentStatus === "Failed"
                              ? "status--failed"
                              : "status--initiated"
                        }`}
                      >
                        {training?.paymentStatus === "Initiated"
                          ? "Pending"
                          : training?.paymentStatus}
                      </p>
                      {/* {training?.paymentStatus} */}
                    </div>
                    {/* <div
                      style={{ width: "100px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {training?.staus}
                    </div> */}
                    <div
                      style={{ width: "150px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {training?.amount?.toLocaleString(
                        "en-NG",
                        formattingOption,
                      )}
                    </div>
                    {/* <div
                      style={{ width: "100px" }}
                      className="dashboard__users__table__row__data"
                    >
                      <Link to={"/dashboard/trainings/" + training?._id}>
                        <button className="dashboard__users__table__row__data__btn">
                          More Details
                        </button>
                      </Link>
                    </div> */}
                  </div>
                );
              })
            )}
          </div>
        </div>

        {pageCount > 1 && (
          <div style={{ marginTop: 40 }}>
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              pageCount={pageCount}
              breakLabel="..."
              //   renderOnZeroPageCount={null}
              onPageChange={handlePageClick}
              // pageRangeDisplayed={itemsPerPage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Training;
